// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from "@tanstack/react-query";

import { client } from "../client.gen";
import {
  addContentToContainer,
  addContentToContainerBatch,
  assignContainersToArea,
  assignContainerToArea,
  changeContentLevelBatch,
  confirmPasswordReset,
  confirmSignUp,
  createArea,
  createArticle,
  createContact,
  createContainer,
  createContainers,
  createContainerType,
  createOrder,
  deleteContainerType,
  deleteContentBatchWithoutCheck,
  deleteExternalSystemSettings,
  getAreaById,
  getAreas,
  getContactById,
  getContacts,
  getContainerById,
  getContainers,
  getContainerStatistics,
  getContainerType,
  getContainerTypes,
  getContentLevelEventStatistics,
  getCuttingLengths,
  getDeliverySchedule,
  getHumidityLevels,
  getMe,
  getOrder,
  getOrders,
  getPriceOverrides,
  getPrices,
  getPriceSettings,
  getVersion,
  getWoodTypes,
  health,
  info,
  links,
  listArticles,
  listExternalSystemsSettings,
  type Options,
  scheduleDelivery,
  sendConfirmationMail,
  setPriceOverrides,
  setPriceSettings,
  signIn,
  signOut,
  signUp,
  startPasswordReset,
  storeExternalSystemSettings,
  triggerSync,
  unscheduleDelivery,
  updateArea,
  updateContactById,
  updateContainer,
  updateContainerType,
  updateExternalSystemSettings,
  updateOrder,
} from "../sdk.gen";
import type {
  AddContentToContainerBatchData,
  AddContentToContainerBatchError,
  AddContentToContainerBatchResponse,
  AddContentToContainerData,
  AddContentToContainerError,
  AssignContainersToAreaData,
  AssignContainersToAreaError,
  AssignContainerToAreaData,
  AssignContainerToAreaError,
  ChangeContentLevelBatchData,
  ChangeContentLevelBatchError,
  ChangeContentLevelBatchResponse,
  ConfirmPasswordResetData,
  ConfirmPasswordResetError,
  ConfirmSignUpData,
  ConfirmSignUpError,
  CreateAreaData,
  CreateAreaError,
  CreateAreaResponse,
  CreateArticleData,
  CreateArticleError,
  CreateArticleResponse,
  CreateContactData,
  CreateContactError,
  CreateContactResponse,
  CreateContainerData,
  CreateContainerError,
  CreateContainerResponse,
  CreateContainersData,
  CreateContainersError,
  CreateContainersResponse,
  CreateContainerTypeData,
  CreateContainerTypeError,
  CreateContainerTypeResponse,
  CreateOrderData,
  CreateOrderError,
  CreateOrderResponse,
  DeleteContainerTypeData,
  DeleteContainerTypeError,
  DeleteContentBatchWithoutCheckData,
  DeleteContentBatchWithoutCheckError,
  DeleteContentBatchWithoutCheckResponse,
  DeleteExternalSystemSettingsData,
  DeleteExternalSystemSettingsError,
  DeleteExternalSystemSettingsResponse,
  GetAreaByIdData,
  GetAreaByIdError,
  GetAreaByIdResponse,
  GetAreasData,
  GetAreasError,
  GetAreasResponse,
  GetContactByIdData,
  GetContactByIdError,
  GetContactByIdResponse,
  GetContactsData,
  GetContactsError,
  GetContactsResponse,
  GetContainerByIdData,
  GetContainerByIdError,
  GetContainerByIdResponse,
  GetContainersData,
  GetContainersError,
  GetContainersResponse,
  GetContainerStatisticsData,
  GetContainerStatisticsError,
  GetContainerStatisticsResponse,
  GetContainerTypeData,
  GetContainerTypeError,
  GetContainerTypeResponse,
  GetContainerTypesData,
  GetContainerTypesError,
  GetContainerTypesResponse,
  GetContentLevelEventStatisticsData,
  GetContentLevelEventStatisticsError,
  GetContentLevelEventStatisticsResponse,
  GetCuttingLengthsData,
  GetCuttingLengthsError,
  GetCuttingLengthsResponse,
  GetDeliveryScheduleData,
  GetDeliveryScheduleError,
  GetDeliveryScheduleResponse,
  GetHumidityLevelsData,
  GetHumidityLevelsError,
  GetHumidityLevelsResponse,
  GetMeData,
  GetMeError,
  GetMeResponse,
  GetOrderData,
  GetOrderError,
  GetOrderResponse,
  GetOrdersData,
  GetOrdersError,
  GetOrdersResponse,
  GetPriceOverridesData,
  GetPriceOverridesError,
  GetPriceOverridesResponse,
  GetPricesData,
  GetPricesError,
  GetPriceSettingsData,
  GetPriceSettingsError,
  GetPriceSettingsResponse,
  GetPricesResponse,
  GetVersionData,
  GetVersionError,
  GetVersionResponse,
  GetWoodTypesData,
  GetWoodTypesError,
  GetWoodTypesResponse,
  HealthData,
  HealthError,
  HealthResponse,
  InfoData,
  InfoError,
  InfoResponse,
  LinksData,
  LinksError,
  LinksResponse,
  ListArticlesData,
  ListArticlesError,
  ListArticlesResponse,
  ListExternalSystemsSettingsData,
  ListExternalSystemsSettingsError,
  ListExternalSystemsSettingsResponse,
  ScheduleDeliveryData,
  ScheduleDeliveryError,
  ScheduleDeliveryResponse,
  SendConfirmationMailData,
  SendConfirmationMailError,
  SetPriceOverridesData,
  SetPriceOverridesError,
  SetPriceSettingsData,
  SetPriceSettingsError,
  SignInData,
  SignInError,
  SignInResponse,
  SignOutData,
  SignOutError,
  SignUpData,
  SignUpError,
  StartPasswordResetData,
  StartPasswordResetError,
  StoreExternalSystemSettingsData,
  StoreExternalSystemSettingsError,
  StoreExternalSystemSettingsResponse,
  TriggerSyncData,
  TriggerSyncError,
  TriggerSyncResponse,
  UnscheduleDeliveryData,
  UnscheduleDeliveryError,
  UnscheduleDeliveryResponse,
  UpdateAreaData,
  UpdateAreaError,
  UpdateAreaResponse,
  UpdateContactByIdData,
  UpdateContactByIdError,
  UpdateContainerData,
  UpdateContainerError,
  UpdateContainerResponse,
  UpdateContainerTypeData,
  UpdateContainerTypeError,
  UpdateContainerTypeResponse,
  UpdateExternalSystemSettingsData,
  UpdateExternalSystemSettingsError,
  UpdateExternalSystemSettingsResponse,
  UpdateOrderData,
  UpdateOrderError,
  UpdateOrderResponse,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const linksQueryKey = (options?: Options<LinksData>) => createQueryKey("links", options);

/**
 * Actuator root web endpoint
 */
export const linksOptions = (options?: Options<LinksData>) =>
  queryOptions<LinksResponse, LinksError, LinksResponse, ReturnType<typeof linksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await links({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: linksQueryKey(options),
  });

export const healthQueryKey = (options?: Options<HealthData>) => createQueryKey("health", options);

/**
 * Actuator web endpoint 'health'
 */
export const healthOptions = (options?: Options<HealthData>) =>
  queryOptions<HealthResponse, HealthError, HealthResponse, ReturnType<typeof healthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await health({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthQueryKey(options),
  });

export const infoQueryKey = (options?: Options<InfoData>) => createQueryKey("info", options);

/**
 * Actuator web endpoint 'info'
 */
export const infoOptions = (options?: Options<InfoData>) =>
  queryOptions<InfoResponse, InfoError, InfoResponse, ReturnType<typeof infoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await info({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: infoQueryKey(options),
  });

export const getAreasQueryKey = (options?: Options<GetAreasData>) => createQueryKey("getAreas", options);

export const getAreasOptions = (options?: Options<GetAreasData>) =>
  queryOptions<GetAreasResponse, GetAreasError, GetAreasResponse, ReturnType<typeof getAreasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAreas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAreasQueryKey(options),
  });

export const createAreaMutation = (
  options?: Partial<Options<CreateAreaData>>,
): UseMutationOptions<CreateAreaResponse, CreateAreaError, Options<CreateAreaData>> => {
  const mutationOptions: UseMutationOptions<CreateAreaResponse, CreateAreaError, Options<CreateAreaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createArea({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAreaByIdQueryKey = (options: Options<GetAreaByIdData>) => createQueryKey("getAreaById", options);

export const getAreaByIdOptions = (options: Options<GetAreaByIdData>) =>
  queryOptions<GetAreaByIdResponse, GetAreaByIdError, GetAreaByIdResponse, ReturnType<typeof getAreaByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAreaById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAreaByIdQueryKey(options),
  });

export const updateAreaMutation = (
  options?: Partial<Options<UpdateAreaData>>,
): UseMutationOptions<UpdateAreaResponse, UpdateAreaError, Options<UpdateAreaData>> => {
  const mutationOptions: UseMutationOptions<UpdateAreaResponse, UpdateAreaError, Options<UpdateAreaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateArea({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const assignContainerToAreaMutation = (
  options?: Partial<Options<AssignContainerToAreaData>>,
): UseMutationOptions<unknown, AssignContainerToAreaError, Options<AssignContainerToAreaData>> => {
  const mutationOptions: UseMutationOptions<unknown, AssignContainerToAreaError, Options<AssignContainerToAreaData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await assignContainerToArea({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const assignContainersToAreaMutation = (
  options?: Partial<Options<AssignContainersToAreaData>>,
): UseMutationOptions<unknown, AssignContainersToAreaError, Options<AssignContainersToAreaData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AssignContainersToAreaError,
    Options<AssignContainersToAreaData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assignContainersToArea({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listArticlesQueryKey = (options?: Options<ListArticlesData>) => createQueryKey("listArticles", options);

export const listArticlesOptions = (options?: Options<ListArticlesData>) =>
  queryOptions<ListArticlesResponse, ListArticlesError, ListArticlesResponse, ReturnType<typeof listArticlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listArticles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listArticlesQueryKey(options),
  });

export const createArticleMutation = (
  options?: Partial<Options<CreateArticleData>>,
): UseMutationOptions<CreateArticleResponse, CreateArticleError, Options<CreateArticleData>> => {
  const mutationOptions: UseMutationOptions<CreateArticleResponse, CreateArticleError, Options<CreateArticleData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createArticle({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getContactsQueryKey = (options?: Options<GetContactsData>) => createQueryKey("getContacts", options);

export const getContactsOptions = (options?: Options<GetContactsData>) =>
  queryOptions<GetContactsResponse, GetContactsError, GetContactsResponse, ReturnType<typeof getContactsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContacts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContactsQueryKey(options),
  });

export const createContactMutation = (
  options?: Partial<Options<CreateContactData>>,
): UseMutationOptions<CreateContactResponse, CreateContactError, Options<CreateContactData>> => {
  const mutationOptions: UseMutationOptions<CreateContactResponse, CreateContactError, Options<CreateContactData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createContact({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getContactByIdQueryKey = (options: Options<GetContactByIdData>) =>
  createQueryKey("getContactById", options);

export const getContactByIdOptions = (options: Options<GetContactByIdData>) =>
  queryOptions<
    GetContactByIdResponse,
    GetContactByIdError,
    GetContactByIdResponse,
    ReturnType<typeof getContactByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContactById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContactByIdQueryKey(options),
  });

export const updateContactByIdMutation = (
  options?: Partial<Options<UpdateContactByIdData>>,
): UseMutationOptions<unknown, UpdateContactByIdError, Options<UpdateContactByIdData>> => {
  const mutationOptions: UseMutationOptions<unknown, UpdateContactByIdError, Options<UpdateContactByIdData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateContactById({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getContainerTypesQueryKey = (options?: Options<GetContainerTypesData>) =>
  createQueryKey("getContainerTypes", options);

export const getContainerTypesOptions = (options?: Options<GetContainerTypesData>) =>
  queryOptions<
    GetContainerTypesResponse,
    GetContainerTypesError,
    GetContainerTypesResponse,
    ReturnType<typeof getContainerTypesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContainerTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContainerTypesQueryKey(options),
  });

export const createContainerTypeMutation = (
  options?: Partial<Options<CreateContainerTypeData>>,
): UseMutationOptions<CreateContainerTypeResponse, CreateContainerTypeError, Options<CreateContainerTypeData>> => {
  const mutationOptions: UseMutationOptions<
    CreateContainerTypeResponse,
    CreateContainerTypeError,
    Options<CreateContainerTypeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createContainerType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteContainerTypeMutation = (
  options?: Partial<Options<DeleteContainerTypeData>>,
): UseMutationOptions<unknown, DeleteContainerTypeError, Options<DeleteContainerTypeData>> => {
  const mutationOptions: UseMutationOptions<unknown, DeleteContainerTypeError, Options<DeleteContainerTypeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteContainerType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getContainerTypeQueryKey = (options: Options<GetContainerTypeData>) =>
  createQueryKey("getContainerType", options);

export const getContainerTypeOptions = (options: Options<GetContainerTypeData>) =>
  queryOptions<
    GetContainerTypeResponse,
    GetContainerTypeError,
    GetContainerTypeResponse,
    ReturnType<typeof getContainerTypeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContainerType({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContainerTypeQueryKey(options),
  });

export const updateContainerTypeMutation = (
  options?: Partial<Options<UpdateContainerTypeData>>,
): UseMutationOptions<UpdateContainerTypeResponse, UpdateContainerTypeError, Options<UpdateContainerTypeData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateContainerTypeResponse,
    UpdateContainerTypeError,
    Options<UpdateContainerTypeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateContainerType({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getContainersQueryKey = (options?: Options<GetContainersData>) => createQueryKey("getContainers", options);

export const getContainersOptions = (options?: Options<GetContainersData>) =>
  queryOptions<
    GetContainersResponse,
    GetContainersError,
    GetContainersResponse,
    ReturnType<typeof getContainersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContainers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContainersQueryKey(options),
  });

export const createContainerMutation = (
  options?: Partial<Options<CreateContainerData>>,
): UseMutationOptions<CreateContainerResponse, CreateContainerError, Options<CreateContainerData>> => {
  const mutationOptions: UseMutationOptions<
    CreateContainerResponse,
    CreateContainerError,
    Options<CreateContainerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createContainer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createContainersMutation = (
  options?: Partial<Options<CreateContainersData>>,
): UseMutationOptions<CreateContainersResponse, CreateContainersError, Options<CreateContainersData>> => {
  const mutationOptions: UseMutationOptions<
    CreateContainersResponse,
    CreateContainersError,
    Options<CreateContainersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createContainers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getContainerByIdQueryKey = (options: Options<GetContainerByIdData>) =>
  createQueryKey("getContainerById", options);

export const getContainerByIdOptions = (options: Options<GetContainerByIdData>) =>
  queryOptions<
    GetContainerByIdResponse,
    GetContainerByIdError,
    GetContainerByIdResponse,
    ReturnType<typeof getContainerByIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContainerById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContainerByIdQueryKey(options),
  });

export const updateContainerMutation = (
  options?: Partial<Options<UpdateContainerData>>,
): UseMutationOptions<UpdateContainerResponse, UpdateContainerError, Options<UpdateContainerData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateContainerResponse,
    UpdateContainerError,
    Options<UpdateContainerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateContainer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const addContentToContainerMutation = (
  options?: Partial<Options<AddContentToContainerData>>,
): UseMutationOptions<unknown, AddContentToContainerError, Options<AddContentToContainerData>> => {
  const mutationOptions: UseMutationOptions<unknown, AddContentToContainerError, Options<AddContentToContainerData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addContentToContainer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteContentBatchWithoutCheckMutation = (
  options?: Partial<Options<DeleteContentBatchWithoutCheckData>>,
): UseMutationOptions<
  DeleteContentBatchWithoutCheckResponse,
  DeleteContentBatchWithoutCheckError,
  Options<DeleteContentBatchWithoutCheckData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteContentBatchWithoutCheckResponse,
    DeleteContentBatchWithoutCheckError,
    Options<DeleteContentBatchWithoutCheckData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteContentBatchWithoutCheck({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const addContentToContainerBatchMutation = (
  options?: Partial<Options<AddContentToContainerBatchData>>,
): UseMutationOptions<
  AddContentToContainerBatchResponse,
  AddContentToContainerBatchError,
  Options<AddContentToContainerBatchData>
> => {
  const mutationOptions: UseMutationOptions<
    AddContentToContainerBatchResponse,
    AddContentToContainerBatchError,
    Options<AddContentToContainerBatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addContentToContainerBatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const changeContentLevelBatchMutation = (
  options?: Partial<Options<ChangeContentLevelBatchData>>,
): UseMutationOptions<
  ChangeContentLevelBatchResponse,
  ChangeContentLevelBatchError,
  Options<ChangeContentLevelBatchData>
> => {
  const mutationOptions: UseMutationOptions<
    ChangeContentLevelBatchResponse,
    ChangeContentLevelBatchError,
    Options<ChangeContentLevelBatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await changeContentLevelBatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listExternalSystemsSettingsQueryKey = (options?: Options<ListExternalSystemsSettingsData>) =>
  createQueryKey("listExternalSystemsSettings", options);

export const listExternalSystemsSettingsOptions = (options?: Options<ListExternalSystemsSettingsData>) =>
  queryOptions<
    ListExternalSystemsSettingsResponse,
    ListExternalSystemsSettingsError,
    ListExternalSystemsSettingsResponse,
    ReturnType<typeof listExternalSystemsSettingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listExternalSystemsSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listExternalSystemsSettingsQueryKey(options),
  });

export const storeExternalSystemSettingsMutation = (
  options?: Partial<Options<StoreExternalSystemSettingsData>>,
): UseMutationOptions<
  StoreExternalSystemSettingsResponse,
  StoreExternalSystemSettingsError,
  Options<StoreExternalSystemSettingsData>
> => {
  const mutationOptions: UseMutationOptions<
    StoreExternalSystemSettingsResponse,
    StoreExternalSystemSettingsError,
    Options<StoreExternalSystemSettingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await storeExternalSystemSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const triggerSyncMutation = (
  options?: Partial<Options<TriggerSyncData>>,
): UseMutationOptions<TriggerSyncResponse, TriggerSyncError, Options<TriggerSyncData>> => {
  const mutationOptions: UseMutationOptions<TriggerSyncResponse, TriggerSyncError, Options<TriggerSyncData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await triggerSync({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const deleteExternalSystemSettingsMutation = (
  options?: Partial<Options<DeleteExternalSystemSettingsData>>,
): UseMutationOptions<
  DeleteExternalSystemSettingsResponse,
  DeleteExternalSystemSettingsError,
  Options<DeleteExternalSystemSettingsData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteExternalSystemSettingsResponse,
    DeleteExternalSystemSettingsError,
    Options<DeleteExternalSystemSettingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteExternalSystemSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateExternalSystemSettingsMutation = (
  options?: Partial<Options<UpdateExternalSystemSettingsData>>,
): UseMutationOptions<
  UpdateExternalSystemSettingsResponse,
  UpdateExternalSystemSettingsError,
  Options<UpdateExternalSystemSettingsData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateExternalSystemSettingsResponse,
    UpdateExternalSystemSettingsError,
    Options<UpdateExternalSystemSettingsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateExternalSystemSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMeQueryKey = (options?: Options<GetMeData>) => createQueryKey("getMe", options);

export const getMeOptions = (options?: Options<GetMeData>) =>
  queryOptions<GetMeResponse, GetMeError, GetMeResponse, ReturnType<typeof getMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMe({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMeQueryKey(options),
  });

export const startPasswordResetMutation = (
  options?: Partial<Options<StartPasswordResetData>>,
): UseMutationOptions<unknown, StartPasswordResetError, Options<StartPasswordResetData>> => {
  const mutationOptions: UseMutationOptions<unknown, StartPasswordResetError, Options<StartPasswordResetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await startPasswordReset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const confirmPasswordResetMutation = (
  options?: Partial<Options<ConfirmPasswordResetData>>,
): UseMutationOptions<unknown, ConfirmPasswordResetError, Options<ConfirmPasswordResetData>> => {
  const mutationOptions: UseMutationOptions<unknown, ConfirmPasswordResetError, Options<ConfirmPasswordResetData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await confirmPasswordReset({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const signInMutation = (
  options?: Partial<Options<SignInData>>,
): UseMutationOptions<SignInResponse, SignInError, Options<SignInData>> => {
  const mutationOptions: UseMutationOptions<SignInResponse, SignInError, Options<SignInData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await signIn({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const signOutMutation = (
  options?: Partial<Options<SignOutData>>,
): UseMutationOptions<unknown, SignOutError, Options<SignOutData>> => {
  const mutationOptions: UseMutationOptions<unknown, SignOutError, Options<SignOutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await signOut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const signUpMutation = (
  options?: Partial<Options<SignUpData>>,
): UseMutationOptions<unknown, SignUpError, Options<SignUpData>> => {
  const mutationOptions: UseMutationOptions<unknown, SignUpError, Options<SignUpData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await signUp({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const confirmSignUpQueryKey = (options: Options<ConfirmSignUpData>) => createQueryKey("confirmSignUp", options);

export const confirmSignUpOptions = (options: Options<ConfirmSignUpData>) =>
  queryOptions<unknown, ConfirmSignUpError, unknown, ReturnType<typeof confirmSignUpQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confirmSignUp({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: confirmSignUpQueryKey(options),
  });

export const getVersionQueryKey = (options?: Options<GetVersionData>) => createQueryKey("getVersion", options);

export const getVersionOptions = (options?: Options<GetVersionData>) =>
  queryOptions<GetVersionResponse, GetVersionError, GetVersionResponse, ReturnType<typeof getVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVersion({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getVersionQueryKey(options),
  });

export const sendConfirmationMailMutation = (
  options?: Partial<Options<SendConfirmationMailData>>,
): UseMutationOptions<unknown, SendConfirmationMailError, Options<SendConfirmationMailData>> => {
  const mutationOptions: UseMutationOptions<unknown, SendConfirmationMailError, Options<SendConfirmationMailData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await sendConfirmationMail({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrdersQueryKey = (options?: Options<GetOrdersData>) => createQueryKey("getOrders", options);

export const getOrdersOptions = (options?: Options<GetOrdersData>) =>
  queryOptions<GetOrdersResponse, GetOrdersError, GetOrdersResponse, ReturnType<typeof getOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrders({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrdersQueryKey(options),
  });

export const createOrderMutation = (
  options?: Partial<Options<CreateOrderData>>,
): UseMutationOptions<CreateOrderResponse, CreateOrderError, Options<CreateOrderData>> => {
  const mutationOptions: UseMutationOptions<CreateOrderResponse, CreateOrderError, Options<CreateOrderData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOrder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const unscheduleDeliveryMutation = (
  options?: Partial<Options<UnscheduleDeliveryData>>,
): UseMutationOptions<UnscheduleDeliveryResponse, UnscheduleDeliveryError, Options<UnscheduleDeliveryData>> => {
  const mutationOptions: UseMutationOptions<
    UnscheduleDeliveryResponse,
    UnscheduleDeliveryError,
    Options<UnscheduleDeliveryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unscheduleDelivery({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDeliveryScheduleQueryKey = (options: Options<GetDeliveryScheduleData>) =>
  createQueryKey("getDeliverySchedule", options);

export const getDeliveryScheduleOptions = (options: Options<GetDeliveryScheduleData>) =>
  queryOptions<
    GetDeliveryScheduleResponse,
    GetDeliveryScheduleError,
    GetDeliveryScheduleResponse,
    ReturnType<typeof getDeliveryScheduleQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDeliverySchedule({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDeliveryScheduleQueryKey(options),
  });

export const scheduleDeliveryMutation = (
  options?: Partial<Options<ScheduleDeliveryData>>,
): UseMutationOptions<ScheduleDeliveryResponse, ScheduleDeliveryError, Options<ScheduleDeliveryData>> => {
  const mutationOptions: UseMutationOptions<
    ScheduleDeliveryResponse,
    ScheduleDeliveryError,
    Options<ScheduleDeliveryData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await scheduleDelivery({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrderQueryKey = (options: Options<GetOrderData>) => createQueryKey("getOrder", options);

export const getOrderOptions = (options: Options<GetOrderData>) =>
  queryOptions<GetOrderResponse, GetOrderError, GetOrderResponse, ReturnType<typeof getOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrder({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrderQueryKey(options),
  });

export const updateOrderMutation = (
  options?: Partial<Options<UpdateOrderData>>,
): UseMutationOptions<UpdateOrderResponse, UpdateOrderError, Options<UpdateOrderData>> => {
  const mutationOptions: UseMutationOptions<UpdateOrderResponse, UpdateOrderError, Options<UpdateOrderData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOrder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPriceOverridesQueryKey = (options?: Options<GetPriceOverridesData>) =>
  createQueryKey("getPriceOverrides", options);

export const getPriceOverridesOptions = (options?: Options<GetPriceOverridesData>) =>
  queryOptions<
    GetPriceOverridesResponse,
    GetPriceOverridesError,
    GetPriceOverridesResponse,
    ReturnType<typeof getPriceOverridesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPriceOverrides({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPriceOverridesQueryKey(options),
  });

export const setPriceOverridesMutation = (
  options?: Partial<Options<SetPriceOverridesData>>,
): UseMutationOptions<unknown, SetPriceOverridesError, Options<SetPriceOverridesData>> => {
  const mutationOptions: UseMutationOptions<unknown, SetPriceOverridesError, Options<SetPriceOverridesData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setPriceOverrides({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPriceSettingsQueryKey = (options?: Options<GetPriceSettingsData>) =>
  createQueryKey("getPriceSettings", options);

export const getPriceSettingsOptions = (options?: Options<GetPriceSettingsData>) =>
  queryOptions<
    GetPriceSettingsResponse,
    GetPriceSettingsError,
    GetPriceSettingsResponse,
    ReturnType<typeof getPriceSettingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPriceSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPriceSettingsQueryKey(options),
  });

export const setPriceSettingsMutation = (
  options?: Partial<Options<SetPriceSettingsData>>,
): UseMutationOptions<unknown, SetPriceSettingsError, Options<SetPriceSettingsData>> => {
  const mutationOptions: UseMutationOptions<unknown, SetPriceSettingsError, Options<SetPriceSettingsData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await setPriceSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPricesQueryKey = (options?: Options<GetPricesData>) => createQueryKey("getPrices", options);

export const getPricesOptions = (options?: Options<GetPricesData>) =>
  queryOptions<GetPricesResponse, GetPricesError, GetPricesResponse, ReturnType<typeof getPricesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPrices({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPricesQueryKey(options),
  });

export const getCuttingLengthsQueryKey = (options?: Options<GetCuttingLengthsData>) =>
  createQueryKey("getCuttingLengths", options);

export const getCuttingLengthsOptions = (options?: Options<GetCuttingLengthsData>) =>
  queryOptions<
    GetCuttingLengthsResponse,
    GetCuttingLengthsError,
    GetCuttingLengthsResponse,
    ReturnType<typeof getCuttingLengthsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCuttingLengths({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCuttingLengthsQueryKey(options),
  });

export const getHumidityLevelsQueryKey = (options?: Options<GetHumidityLevelsData>) =>
  createQueryKey("getHumidityLevels", options);

export const getHumidityLevelsOptions = (options?: Options<GetHumidityLevelsData>) =>
  queryOptions<
    GetHumidityLevelsResponse,
    GetHumidityLevelsError,
    GetHumidityLevelsResponse,
    ReturnType<typeof getHumidityLevelsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getHumidityLevels({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getHumidityLevelsQueryKey(options),
  });

export const getWoodTypesQueryKey = (options?: Options<GetWoodTypesData>) => createQueryKey("getWoodTypes", options);

export const getWoodTypesOptions = (options?: Options<GetWoodTypesData>) =>
  queryOptions<GetWoodTypesResponse, GetWoodTypesError, GetWoodTypesResponse, ReturnType<typeof getWoodTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getWoodTypes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getWoodTypesQueryKey(options),
  });

export const getContainerStatisticsQueryKey = (options?: Options<GetContainerStatisticsData>) =>
  createQueryKey("getContainerStatistics", options);

export const getContainerStatisticsOptions = (options?: Options<GetContainerStatisticsData>) =>
  queryOptions<
    GetContainerStatisticsResponse,
    GetContainerStatisticsError,
    GetContainerStatisticsResponse,
    ReturnType<typeof getContainerStatisticsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContainerStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContainerStatisticsQueryKey(options),
  });

export const getContentLevelEventStatisticsQueryKey = (options?: Options<GetContentLevelEventStatisticsData>) =>
  createQueryKey("getContentLevelEventStatistics", options);

export const getContentLevelEventStatisticsOptions = (options?: Options<GetContentLevelEventStatisticsData>) =>
  queryOptions<
    GetContentLevelEventStatisticsResponse,
    GetContentLevelEventStatisticsError,
    GetContentLevelEventStatisticsResponse,
    ReturnType<typeof getContentLevelEventStatisticsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getContentLevelEventStatistics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getContentLevelEventStatisticsQueryKey(options),
  });
